// src/components/icons/ToyBikeIcon.jsx
import React from "react";

const ToyBikeIcon = ({
  width = "1em",
  height = "1em",
  stroke = "currentColor",
  className = ""
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M37 42C40.866 42 44 38.866 44 35C44 31.134 40.866 28 37 28C33.134 28 30 31.134 30 35C30 38.866 33.134 42 37 42Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 42C14.866 42 18 38.866 18 35C18 31.134 14.866 28 11 28C7.13401 28 4 31.134 4 35C4 38.866 7.13401 42 11 42Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30 12C31.1046 12 32 11.1046 32 10C32 8.89543 31.1046 8 30 8C28.8954 8 28 8.89543 28 10C28 11.1046 28.8954 12 30 12Z"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 35V28L18 22L26 16L30 22H34"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ToyBikeIcon;
